import React from "react";
import ReactToPrint from "react-to-print";
import {
    Dispatch,
    CustOutstand,
    BNumberList,
    ProcessCompletedList,
    PrintYarnList,
    ProcessUpdatesList,
    FabricPricePendingList,
    FabricLibraryList,
    SampleLibraryList,
    SampleReportByProcessesList,
    PatterMasterReportList,
    StyleDownloadsList
} from "../../components/Report/reports";
export default class ComponentToPrint extends React.Component {
    state = {
        fabricReportList: [],
        type: ""
    }
    componentWillMount() {
        const { fabricReportList, body, header, arrayValue, type } = this.props;

        this.setState({ fabricReportList, body, header, arrayValue, type })
    }

    componentWillReceiveProps(nextProps) {
        const { fabricReportList, body, header, arrayValue, type } = nextProps;

        this.setState({ fabricReportList, body, header, arrayValue, type })
    }
    render() {
        let { fabricReportList, body, header, arrayValue } = this.state;
        return (
            <table
                id="report-list-height1"
                className="report-list-height1 mt-5"
                onScroll={this.state.type !== 'sampleLibrary' && this.handleScroll}
            >
                {this.state.type === "fabric" && (
                    <tr>
                        {fabricReportList !== undefined &&
                            fabricReportList.length > 0 &&
                            Object.keys(fabricReportList[0]).map(data => {
                                if (data !== "ID")
                                    return <td className="report-header">{data}</td>;
                            })}
                    </tr>
                )}
                {this.state.type === "dispatch" && (
                    <Dispatch
                        list={fabricReportList}
                        displayData={this.displayData}
                    />
                )}
                {this.state.type === "bNumber" && (
                    <BNumberList
                        list={fabricReportList}
                    />
                )}
                {this.state.type === "fabPricePending" && (
                    <FabricPricePendingList
                        list={fabricReportList}
                        processType={this.state.processType}
                        history={this.props.history}
                    />
                )}
                {this.state.type === "fabricLibrary" && (
                    <FabricLibraryList
                        modalData={this.modalData}
                        list={fabricReportList}
                        processType={this.state.processType}
                        history={this.props.history}
                    />
                )}
                {this.state.type === "sampleProcesses" && (
                    <SampleReportByProcessesList
                        sampleRights={this.props.sampleRequest}
                        modalData={this.modalData}
                        list={body}
                        processType={this.state.processType}
                        history={this.props.history}
                        disabled={this.state.disabled}
                        header={header}
                        showHeaders={arrayValue}
                    />
                )}
                {this.state.type === "sampleLibrary" && (
                    <SampleLibraryList
                        modalData={this.modalData}
                        list={fabricReportList}
                        processType={this.state.processType}
                        history={this.props.history}
                    />
                )}
                {this.state.type === "processCompleted" && (
                    <ProcessCompletedList
                        list={fabricReportList}
                        processType={this.state.processType}
                        history={this.props.history}
                    />
                )}
                {(this.state.type === "processUpdates" || this.state.type === "bulkUpdateProcess") && ( // sample awaiting material
                    <ProcessUpdatesList
                        type={this.state.type}
                        list={fabricReportList}
                        processType={this.state.processType}
                        history={this.props.history}
                        sorting={this.sorting}
                        handleCheckBox={this.handleCheckBox}
                        all={this.state.all}
                    />
                )}
                {this.state.type === "fabric" &&
                    fabricReportList !== undefined &&
                    Array.isArray(fabricReportList) &&
                    fabricReportList.length > 0 &&
                    fabricReportList.map((data, index) => (
                        <tr>
                            {Object.keys(data).map(dat => {
                                if (dat == "IMAGE" && data[dat] != "") {
                                    return (
                                        <td>
                                            <img
                                                src={`${data[dat]}`}
                                                style={{ width: " 50px", height: "50px" }}
                                            />
                                        </td>
                                    );
                                } else if (
                                    dat == "DEV REF NUMBER" ||
                                    dat == "FABRIC REF NO"
                                ) {
                                    return (
                                        <td>
                                            <p>{data[dat]}</p>
                                        </td>
                                    );
                                } else if (dat != "ID") {
                                    return <td>{data[dat]}</td>;
                                }
                            })}
                        </tr>
                    ))}
                {this.state.type === "custDept" && body && body.length > 0 && (
                    <CustOutstand
                        state={this.state}
                        list={body}
                        header={header}
                        history={this.props.history}
                        getalertMessage={this.props.getalertMessage}
                        changeBg={this.changeBg}
                        setTitle={this.setTitle}
                        modalData={this.modalData}
                    />
                )}
                {this.state.type === "patternMasterReport" && (
                    <PatterMasterReportList
                        list={fabricReportList}
                        processType={this.state.processType}
                        history={this.props.history}
                    />
                )}
                {(this.state.type === "styleDownloads" || this.state.type === "sampleRequestDownloads") && (
                    <StyleDownloadsList
                        list={fabricReportList}
                        processType={this.state.processType}
                        history={this.props.history}
                    />
                )}
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/report/print.js